<template>
	<div
		:class="['panel', 'donation_whattodo',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
		]"
	>
		<div class="container">
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand? 'sk' : '',
				]"
			>
				<h2>{{ block.block_title }}</h2>
			</div>

			<ul class="todo_list row">
				<li v-for="(item, index) in block.items" :key="index" class="col col-12 col-lg-4">
					<div class="todo-item primary">
						<div class="todo-item_top">
							<div
								v-if="item.image"
								class="image"
								@click.prevent="item.text_popup ?
									$bvModal.show('popup_' + block.id + '-' + index) : ''"
							>
								<b-img-lazy :src="item.image" :alt="item.title" />
							</div>
							<div
								class="title"
								@click.prevent="item.text_popup ?
									$bvModal.show('popup_' + block.id + '-' + index) : ''"
							>
								{{ item.title }}
							</div>
						</div>
						<div v-if="item.url" class="todo-item_bottom">
							<button
								v-if="item.text_popup"
								class="more_link"
								@click.prevent="$bvModal.show('popup_' + block.id + '-' + index)"
							>
								{{ item.url_title }}
							</button>
							<a v-else :href="item.url" class="more_link">
								{{ item.url_title }}
							</a>
						</div>
					</div>
					<b-modal
						v-if="item.text_popup"
						:id="'popup_' + block.id + '-' + index"
						hide-footer
						size="lg"
						@hide="showRu=!showRu"
					>
						<div v-html="item.text_popup" />
						<template v-slot:modal-footer="{ ok }">
							<b-button size="sm" class="rounded-pill" variant="primary" @click="ok()">
								OK
							</b-button>
						</template>
					</b-modal>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'PanelCardsHeighten',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/donation-whattodo";
</style>
